/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Languages_QuestionInputs */

const en_mobile_faq_languages_question = /** @type {(inputs: Mobile_Faq_Languages_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What languages are supported?`)
};

const es_mobile_faq_languages_question = /** @type {(inputs: Mobile_Faq_Languages_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué idiomas son compatibles?`)
};

/**
* | output |
* | --- |
* | "What languages are supported?" |
*
* @param {Mobile_Faq_Languages_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_languages_question = /** @type {((inputs?: Mobile_Faq_Languages_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Languages_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_languages_question(inputs)
	return en_mobile_faq_languages_question(inputs)
});